export default Object.freeze({
    DEFAULT_TITLE: 'FDM Medlems Portal',
});
